import React, { Component } from 'react';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';

const DescriptionContainer = styled(Grid)`
  padding:40px 20%;
  div.MuiGrid-root {
    color:white;
    h2 {
      font-family: 'Averia Serif Libre', serif;
      font-size:200%;
      line-height:2.5;
    }
    p, a, ol li {
      color:white;
      line-height:2;
    }
    ol li {
      font-style:italic;
    }
    a {
      color: #9fff9d;
    }
    span {
      font-weight: bold;
    }
  }

`
class Description extends Component {
  render() {
    return (
      <DescriptionContainer container spacing={3}>
        <Grid item xs={12} md={6}>
          <h2>Diversitree</h2>
            <p>
              Tree diversity, on a species-, genus-, and family-level, is an important factor in securing healthy urban forests and providing ecosystem services for billions of city dwellers. Using open-source data on global tree inventories, <span>Diversitree</span> examines (1) the diversity of species, genera, and family of urban street trees in eight cities internationally; (2) how they score on diversity benchmarks and indices; and (3) the diversity variation inside and outside of cities’ centers. Understanding street tree diversity and spatial variation patterns across cities internationally can offer needed evidence to back up heuristic benchmarks. The methodology and open-source data used in this study are intended to enable practitioners to better target tree diversity efforts.
            </p>
          </Grid>
        <Grid item xs={12} md={6}>
            <h2>
              Publication
            </h2>
            <p>
              Galle, N., Halpern, D., Nitoslawski, S., Duarte, F., Ratti, C., &amp; Pilla, F. (2021). <a href="https://senseable.mit.edu/papers/pdf/20210325_Galle-etal_MappingDiversity_UFUG.pdf" target="_blank" rel="noopener noreferrer">Mapping the diversity of street tree inventories across eight cities
internationally using open data</a>. Urban Forestry and Urban Greening.
            </p>
            <h2>
              Press Material
            </h2>
            <p >
              <a href={`${process.env.PUBLIC_URL}/press.zip`} target="_blank" rel="noopener noreferrer">Download the Press Material</a>
            </p>
            <p>
              The material on this website can be used freely in any publication provided that:
            </p>
            <ol>
              <li>
                1. It is duly credited as a project by the MIT Institute.
              </li>
              <li>
                2. A PDF copy of the publication is sent to senseable-press@mit.edu
              </li>
            </ol>
        </Grid>
      </DescriptionContainer>
    )
  }
}

export default Description;